import React, { useEffect, useState } from "react";
import { dateToString } from "~/utils/formatter";
import { API_STATE } from "~/common/constants/state";
import useRequest from "~/common/hooks/useRequest";
import { Trans, useTranslation } from "react-i18next";

// Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import InvitationModal from "./modal/InvitationModal";
import CompleteModal from "./modal/CompleteModal";
import MemberList from "./contents/MemberList";

// Assets
import "~/assets/sass/pages/mypage/admin/team.scss";
import { TeamPageIcon } from "~/assets/svg/PageIntroIcon";
import useAlert from "~/common/hooks/useAlert";
import { useFieldArray, useForm } from "react-hook-form";
import ResendMailModal from "./modal/ResendMailModal";
import { ViewCard } from "../VcMember/View";
import EditCard from "../VcMember/Edit/EditCard";
import { makeRandomPassword } from "~/utils/password";

const AdminTeamPage = ({ showViewPage, inviteModal, setInviteModal, excelData, setExcelData, error, memberList }) => {
	const { t } = useTranslation();

	const [resendMember, setResendMember] = useState();
	const [teamInviteRequestModal, setTeamInviteRequestModal] = useState(false);
	const [resendMailModal, setResendMailModal] = useState(false);
	const [teamMemberList, setTeamMemberList] = useState(memberList ?? []);
	const [inviteResponseData, setInviteResponseData] = useState([]);
	const [showInfo, setShowInfo] = useState(false)
	const [currentMember, setCurrentMember] = useState()
	const [editMode, setEditMode] = useState(false)

	const [showWithdrawAlert, WithdrawAlert] = useAlert();
	const [showSuccessAlert, SuccessAlert] = useAlert();
	const [showWithdrawSuccessAlert, WithdrawSuccessAlert] = useAlert();

	const invitedTeamMemberRequest = useRequest("get", "/vc/admin/invite");
	const activationRequest = useRequest("post", "/vc/admin/activate");
	const deleteRequest = useRequest("post", "/vc/admin/withdraw");
	const resendRequest = useRequest("post", `/vc/admin/invite/resend/${resendMember?.idx}`);

	const resendMailForm = useForm({
		defaultValues: {
			name: resendMember?.name,
			email: resendMember?.id,
			password: makeRandomPassword(),
		}
	});

	const memberForm = useForm({
		defaultValues: {
			img: "",
			name: "",
			position: "",
			department: "",
			introduction: "",
		},
	});

	const { control, setValue } = memberForm;
	const teamListMutation = useRequest("post", "vc/company/member");

	const userFormSubmit = async ({ member }) => {
		await teamListMutation.asyncCall(member).then(() => {
			setShowInfo(false); setEditMode(false);
		});
		showViewPage();
	};

	const submit = ({ password }) => {
		handleResend(password);
	};

	useEffect(() => {
		invitedTeamMemberRequest.singleCall();
	});

	useEffect(() => {
		switch (invitedTeamMemberRequest.state) {
			case API_STATE.done:
				const newData = invitedTeamMemberRequest.response.data.map((d) => ({
					...d,
					regDate: dateToString(d.regDate, "yyyy-MM-dd"),
				}));
				setTeamMemberList(newData);
				break;
			case API_STATE.error:
				console.log("error", invitedTeamMemberRequest.error);
				break;
			default:
				break;
		}
	}, [
		invitedTeamMemberRequest.state,
		invitedTeamMemberRequest.response,
		invitedTeamMemberRequest.error,
	]);

	useEffect(() => {
		setTeamMemberList(memberList.map((d) => ({
			...d,
			regDate: dateToString(d.regDate, "yyyy-MM-dd"),
		})))
	}, [memberList])

	// Active UnActive
	const handleActive = (idx) => {
		activationRequest.call(idx, "path");
	};

	useEffect(() => {
		switch (activationRequest.state) {
			case API_STATE.done:
				invitedTeamMemberRequest.call();
				break;
			case API_STATE.error:
				console.log("error", activationRequest.error);
				alert(t("common.commonWord.alert.wait2"));
				break;
			default:
				break;
		}
	}, [activationRequest.state, activationRequest.response, activationRequest.error]);

	// Delete
	const handleDelete = async (idx) => {
		showWithdrawAlert()
			.then(() => deleteRequest.call(idx, "path"))
			.catch(() => { });
	};

	useEffect(() => {
		switch (deleteRequest.state) {
			case API_STATE.done:
				invitedTeamMemberRequest.call();
				showWithdrawSuccessAlert()
				break;
			case API_STATE.error:
				console.log("error", deleteRequest.error);
				alert(t("common.commonWord.alert.wait2"));
				break;
			default:
				break;
		}
	}, [deleteRequest.state, deleteRequest.response, deleteRequest.error]);

	// Mail sender
	const handleResend = (password) => {
		console.log(password)
		showSuccessAlert()
			.then(() => {
				resendRequest.call({ password: password }, "body");
				setResendMailModal();
			})
			.catch(() => {
				setResendMailModal();
			});
	};

	const handleClickMember = (member) => {
		setCurrentMember(member)
		Object.keys(member).forEach((key) => {
			setValue(`member.${key}`, member[key] || "");
		});
		setShowInfo(true)
	}

	return (
		<>
			<MemberList
				{...{
					teamMemberList,
					handleActive,
					handleDelete,
					setResendMailModal,
					setResendMember,

				}}
				handleClick={handleClickMember}
			/>
			{/*추가하기 버튼 클릭시 팀원초대 모달*/}
			<ModalTemplate
				modalState={inviteModal}
				setModalToggle={setInviteModal}
				title={t("pages.myPage.admin.TeamPage.inviteModalTitle")}
				width={700}
				height={490}
				className={"modal-team-invite"}
			>
				<InvitationModal
					{...{
						setTeamInviteRequestModal,
						setInviteModal,
						invitedTeamMemberRequest,
						setInviteResponseData,
						excelData, setExcelData, error
					}}
				/>
			</ModalTemplate>
			{/* 이메일 전송 완료 */}
			<ModalTemplate
				modalState={teamInviteRequestModal}
				setModalToggle={setTeamInviteRequestModal}
				title={t("pages.myPage.admin.TeamPage.inviteModalTitle")}
				width={550}
				height={447}
				className={"modal-team-invite"}
			>
				<CompleteModal {...{ inviteResponseData, invitedTeamMemberRequest }} />
			</ModalTemplate>
			{/* 초대 메일 재전송 모달 */}
			<ModalTemplate
				title="초대 메일 재전송"
				width={700}
				height={343}
				modalState={resendMailModal}
				setModalToggle={setResendMailModal}
				className="modal-resend-mail"
			// closeable={true}
			>
				<ResendMailModal
					{...{ resendMailForm, resendMember, setResendMailModal, submit }}
				/>
			</ModalTemplate>
			<SuccessAlert
				message={
					<>
						<h3 className="main-desc">팀원에게 초대 메일을 재전송합니다.</h3>
						<p className="sub-desc">
							비밀번호 변경 후 초대 메일을 재전송할 경우
							<br /> 기존 비밀번호로는 로그인이 불가합니다.
						</p>
					</>
				}
				className="modal-resend-success"
				confirm="확인"
				reject="취소"
			/>
			{/* 팀원 삭제 alert */}
			<WithdrawAlert
				type="warning"
				message={
					"삭제 시 해당 팀원은 목록에서 사라집니다.\n삭제 하시겠습니까?"
				}
				confirm={t("common.commonWord.button.yes")}
				reject={t("common.commonWord.button.no")}
			/>
			<WithdrawSuccessAlert
				type="success"
				message={
					'삭제 완료되었습니다.'
				}
				confirm={'확인'}

			/>

			<ModalTemplate
				// title="팀원 불러오기"
				modalState={showInfo}
				setModalToggle={setShowInfo}
				width={300}
				onClose={() => setEditMode(false)}
			// className="getTeamInfo-modal"
			>
				<div className="company-member-view">
					{currentMember && !editMode ? <ViewCard
						{...currentMember}
					/> :
						< EditCard
							name={(name) => `member.${name}`}
							useForm={memberForm}
						/>
					}
					<div className="alert-footer no-border">
						<button
							type="button"
							className="btn__solid"
							color="gray"
							onClick={() => {
								if (editMode) {
									setEditMode(false)
								}
								else {
									setShowInfo(false)
									setCurrentMember(null)
								}
							}}

						>
							{editMode ? "취소" : '닫기'}
						</button>
						<button
							type={editMode ? 'submit' : "button"}
							className="btn__solid"
							color="primary"
							onClick={() => {

								if (editMode) {
									memberForm.handleSubmit(userFormSubmit)()
								}
								else {
									setEditMode(true)
								}
							}}

						>
							{editMode ? "완료" : '수정'}

						</button>
					</div>
				</div>
			</ModalTemplate >
		</>
	);
};

export default AdminTeamPage;
